import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_CMS, API_BASE_IMG_URl } from "helper/environment";
import Typewriter from "typewriter-effect";
const CommBanner: React.FC = () => {
  const [image, setImage] = useState<any | null>(null);
const [data, setdata] = useState<any | null>(null);
const [include, setinclude] = useState<any | null>(null);
  useEffect(() => {
    const fetchBanner = async () => {
      try {
        const bannerRes = await fetch(
          `${API_BASE_CMS}/jsonapi/node/community_development_page?include=field_image,field_image.field_media_image`
        );
          const bannerJson = await bannerRes.json();
             
                 const node = bannerJson.data[0]; // single object
                 const included = bannerJson.included || [];
                 const getImageFromMedia = (mediaId?: string) => {
                     if (!mediaId) return { url: null, alt: null };
         
                     const media = included.find(
                     (inc: any) =>
                         (inc.type === "media--image" || inc.type === "media--svg_image") &&
                         inc.id === mediaId
                     );
         
                     if (!media) return { url: null, alt: null };
         
                     const imageField =
                     media.relationships?.field_media_image?.data ||
                     media.relationships?.field_media_svg_image?.data;
         
                     if (!imageField?.id) return { url: null, alt: null };
         
                     const file = included.find(
                     (inc: any) => inc.type === "file--file" && inc.id === imageField.id
                     );
         
                     const fileUrl = file?.attributes?.uri?.url
                     ? `${API_BASE_IMG_URl}${file.attributes.uri.url}`
                     : null;
         
                     const altText = imageField?.meta?.alt || media?.attributes?.name || "";
         
                     return {
                     url: fileUrl,
                     alt: altText,
                     };
                 };
                 const Image = node.relationships?.field_image?.data[0]?.id ?? "";  
                 setImage(getImageFromMedia(Image));
                 setdata(node);

      } catch (err) {
        console.error("Community banner fetch failed", err);
      }
    };

    fetchBanner();
  }, []);
   
 const title = data?.attributes.title || "";
  
const banner  =image ? image.url : "assets/img/communityDev/Community Development-Detail Banner.webp";


  
 //console.log(data,banner)
  const banner1="assets/img/communityDev/Community Development-Detail Banner.webp";
   //if(data) return null; 
  return (
        <div className="page-header"
       style={{ backgroundImage: `url(${banner})` }}>
        <div className="container py-5">
            <h2 className="display-3 text-white py-5 mb-3 animated slideInDown text-center">
              {title}
                 {/* <Typewriter
            key={title}
            onInit={(typewriter: any) => {
              typewriter.typeString(title).start();
            }}
            options={{
              delay: 100,
              cursor: "",
            }}
          /> */}
            </h2>
        </div>
    </div>

  );
};

export default CommBanner;
